import { jsxs as k, jsx as t } from "react/jsx-runtime";
import { c } from "../../index-Cu0xwYjD.js";
import { useState as h, useEffect as _ } from "react";
import { propagateTestid as d } from "../../utils/helpers.js";
import { ExpanderMode as E } from "./Expander.types.js";
import { useIdIfNeeded as b } from "../../utils/hooks/useIdIfNeeded.js";
const j = "ids-expander--link-v501", y = "ids-expander--heading-v501", M = "ids-expander--activator-v501", O = "ids-expander--section-v501", $ = "ids-expander-v501", A = "ids-expander--container-v501", S = "ids-expander--open-v501", T = "ids-expander--container-inner-v501", g = "ids-expander--content-v501", e = {
  link: j,
  heading: y,
  activator: M,
  section: O,
  expander: $,
  container: A,
  open: S,
  containerInner: T,
  content: g
}, q = ({
  activator: p,
  children: l,
  className: m,
  "data-testid": a,
  onChange: s,
  id: v,
  mode: x = "section",
  open: i = !1,
  ...f
}) => {
  const [n, r] = h(i), o = b({ id: v }), N = c(
    m,
    e.expander,
    e[x],
    {
      [e.open]: n
    }
  ), I = c(e.container, {
    [e.open]: n
  });
  _(() => {
    r(i);
  }, [i]);
  const u = () => {
    r(!n), s == null || s({ open: !n });
  };
  return /* @__PURE__ */ k(
    "div",
    {
      className: N,
      ...f,
      "data-testid": a,
      id: o,
      children: [
        /* @__PURE__ */ t(
          "button",
          {
            className: e.activator,
            "aria-expanded": n,
            "aria-controls": `${o}__container`,
            onClick: u,
            type: "button",
            "data-testid": d(a, "activator"),
            children: p
          }
        ),
        /* @__PURE__ */ t(
          "div",
          {
            id: `${o}__container`,
            className: I,
            "data-testid": d(a, "container"),
            children: /* @__PURE__ */ t("div", { className: e.containerInner, children: /* @__PURE__ */ t("div", { className: e.content, children: l }) })
          }
        )
      ]
    }
  );
};
q.Mode = E;
export {
  q as IressExpander
};
